<template>
<div>
    <Dialog :dialog="dlgCreateInvoice" max-width="96%">
        <template v-slot:title>Factuur maken</template>
        <template v-slot:content>
                <v-row class="my-0 mx-0 row-workorder-info">
                    <v-col v-if="infoColExpanded" class="col-workorder-info col-sm-4 col-lg-3 py-2 bordered-right px-0" style="min-height:300px">
                        <v-card flat>
                            <v-card-title>Werkbon omschrijving</v-card-title>
                        <v-divider></v-divider>
                            <v-card-text>{{ dlgCreateInvoice.description }}</v-card-text>
                        </v-card>
                        <v-divider></v-divider>
                        <v-card flat>
                            <v-card-title>Uitvoernotities</v-card-title>
                        <v-divider></v-divider>
                            
                            <v-card-text v-for="(appo, index) in dlgCreateInvoice.appointments" :key="index">
                                <div class="text-bold mb-2">
                                    {{ date.fmt.local(appo.dt) }} - {{ appo.employee }}
                                </div>
                                {{ appo.note || 'Geen notitie'}}
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col @click="onToggleInfoCol" class="col-auto w-1 pt-2 bordered-right cursor-pointer" >
                        <Icon v-if="infoColExpanded" type='chevronleft'></Icon>
                        <Icon v-else type='tip' color="primary" title="Toon werkbon omschrijving en werknotities"></Icon>
                        <Icon v-if="false" :type="infoColExpanded ? 'chevronleft' : 'chevronright'"></Icon>
                    </v-col>
                    <v-col class="px-0 py-0">
            <v-form ref="form">
                <LocalTable :model="dlgCreateInvoice" modelLinesProp='lines' :disabled="dlgCreateInvoice.isOpenOrLater" editable can-drag v-if="!false" no-hover dense :dt="tblLines">

                    <template v-slot:header.cmd>                        
                        <Checkbox class="mt-0 ml-0" v-model="dlgCreateInvoice.roAllChecked" @click="()=>dlgCreateInvoice.toggleChecked()"></Checkbox>
                    </template>

                    <template v-slot:row="{ index, item, dt, columnHeaders }">    
                        <LineProduct :key="`p${index}`"  v-if="item.isProductLine||item.isInvoiceLine" :model="dlgCreateInvoice" :item="item" :dt="dt" :columnHeaders="columnHeaders"></LineProduct>
                        <LineHour :key="`h${index}`"     v-else-if="item.isHourLine" :model="dlgCreateInvoice" :item="item" :dt="dt" :columnHeaders="columnHeaders"></LineHour>                    
                        <LineText :key="`t${index}`"     v-else-if="item.isTextLine" :model="dlgCreateInvoice" :item="item" :dt="dt" :columnHeaders="columnHeaders"></LineText>                    

                    </template>


                    <template v-slot:tfoot="{/*dt, hasCmd, */columnHeaders}">


                        <tfoot>
                            <tr v-if="dlgCreateInvoice.lines?.length">                            
                                <td  class="" :colspan="columnHeaders.length-2"></td>                
                                <td  class="text-right pr-3 text-bold"
                                    :class="{'text-success': dlgCreateInvoice.totals.marginPct > 0, 'text-error': dlgCreateInvoice.totals.marginPct <= 0}"
                                >                
                                    <span v-if="!dlgCreateInvoice.lines?.length"></span>
                                    <NoMarginCalculationHint v-else-if="!dlgCreateInvoice.canCalculateMargin" title="Marge kan niet worden berekend">
                                        <p>De marge kan niet worden berekend omdat voor één of meerdere regels geen kostprijs of geen stukprijs is ingevuld.</p>
                                        <p>Vul de tarieven in bij de medewerkers of artikelen, of vul de prijzen in de regels.</p>
                                    </NoMarginCalculationHint>                                                    
                                    <PercentageText v-else v-model='dlgCreateInvoice.totals.marginPct' decimals="0"/>
                                </td>
                                <td></td>
                                <td class="text-right pr-3">
                                    <span class="text-large text-bold">
                                        <AmountText v-model='dlgCreateInvoice.totals.sales'/>
                                    </span>
                                </td>
                            </tr>

                        <tr>                            
                            <td class="vertical-align-top pt-4 pb-6 pl-4" :colspan="columnHeaders.length-5">
                                <span class="no-position-absolute" >

                                    <ActionButton v-if="dlgCreateInvoice.checkedCount" action="salesinvoice.modify" dusk="btn-remove-line" 
                                        class="mr-2"
                                        xsub xmain primary
                                        :model="dlgCreateInvoice" 
                                        :disabled="!dlgCreateInvoice.checkedCount" 
                                        icon="remove"  @click='(evt)=>dlgCreateInvoice.removeCheckedLines(evt)'>Verwijder</ActionButton>
                                    <ActionButton v-if="dlgCreateInvoice.checkedCount>1" 
                                        class="mr-2"
                                        primary xsub xmain
                                        action="salesinvoice.modify" dusk="btn-combine-line" 
                                        :model="dlgCreateInvoice" 
                                        :disabled="!dlgCreateInvoice.checkedCount" 
                                        icon="combine_amount" @click='(evt)=>dlgCreateInvoice.combineCheckedLines(evt)'>Voeg samen</ActionButton>


                                    <ActionButton action="salesinvoice.modify" sub dusk="btn-add-line" :model="dlgCreateInvoice" :disabled="dlgCreateInvoice.isLoading||dlgCreateInvoice.isOpenOrLater" icon="add" xmain xprimary @click='(evt)=>addInvoiceLine(evt)'>Nieuwe regel</ActionButton>
                                    <ActionButton sub dusk="btn-add-text-line" :model="dlgCreateInvoice" dropdown :disabled="dlgCreateInvoice.isLoading||dlgCreateInvoice.isOpenOrLater"  ml icon='text'>
                                        Tekstregel
                                        <template v-slot:dropdown>
                                            <ActionMenuItem  no-icon dusk="btn-add-line-empty-text" :model="dlgCreateInvoice" action='salesinvoice.modify' no-execute :disabled='dlgCreateInvoice.isLoading||dlgCreateInvoice.isOpenOrLater' @click='(evt)=>addEmptyText(evt)'>Lege tekstregel</ActionMenuItem>
                                            <ActionMenuItem  no-icon dusk="btn-add-line-standard-text" :model="dlgCreateInvoice" action='salesinvoice.modify' no-execute :disabled='dlgCreateInvoice.isLoading||dlgCreateInvoice.isOpenOrLater' @click='(evt)=>addStandardText(evt)'>Standaard tekstregel</ActionMenuItem>
                                        </template>
                                    </ActionButton>
                                    <ActionButton sub action="salesinvoice.modify" dusk="btn-add-product" :model="dlgCreateInvoice" ml :disabled="dlgCreateInvoice.isLoading||dlgCreateInvoice.isOpenOrLater" icon=_typeProductLine @click='()=>addProductLine()'>Artikel</ActionButton>
                                </span>
                                <span class="min-h-16"></span>
                            </td>
                            <td class="py-4 text-right text-error text-small pr-3" colspan="6">  
                                <span class="mb-2 cursor-pointer text-primary" @click="dlgCreateInvoice.showTotalSummary =!dlgCreateInvoice.showTotalSummary">
                                    <span v-if="!dlgCreateInvoice.showTotalSummary">
                                        Toon totalen per regeltype
                                    </span>
                                    <span v-else>
                                        Verberg totalen per regeltype
                                    </span>
                                </span>
                            </td>
                        </tr>

                        <tr v-if="dlgCreateInvoice.showTotalSummary" xclass="no-border-top">                            
                            <td class="text-right vertical-align-top py-4 pr-4" :colspan="columnHeaders.length+1">
                                <v-simple-table class="bordered" bordered v-if="dlgCreateInvoice.showTotalSummary"  dense>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th class="pl-8 text-right">Kosten</th>
                                            <th class="pl-8 text-right">Omzet</th>
                                            <th class="pl-8 text-right">Marge</th>                                            
                                            <th class="pl-8 text-right"></th>                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-left">Uren</td>
                                            <td class="pl-8 text-right"><AmountText v-model='dlgCreateInvoice.marginSummary.hours.purchase'/> </td>
                                            <td class="pl-8 text-right"><AmountText v-model='dlgCreateInvoice.marginSummary.hours.sales'/> </td>
                                            <td class="pl-8 text-right text-bold"><AmountText v-model='dlgCreateInvoice.marginSummary.hours.margin'/> </td>
                                            <td class="pl-8 text-right text-bold">
                                                <NoMarginCalculationHint v-if="!dlgCreateInvoice.marginSummary.hours.canMarginPct" title="Marge kan niet worden berekend">
                                                    <p>De marge kan niet worden berekend omdat voor één of meerdere regels geen kostprijs of geen stukprijs is ingevuld.</p>
                                                    <p>Vul de tarieven in bij de medewerkers of vul de prijzen in de regels.</p>
                                                </NoMarginCalculationHint>                                                    
                                                <PercentageText v-else :class="{'text-success': dlgCreateInvoice.marginSummary.hours.marginPct > 0, 'text-error': dlgCreateInvoice.marginSummary.hours.marginPct < 0}" 
                                                    decimals="0" no-border v-model='dlgCreateInvoice.marginSummary.hours.marginPct'/>    
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left">Materiaal</td>
                                            <td class="pl-8 text-right"><AmountText v-model='dlgCreateInvoice.marginSummary.material.purchase'/> </td>
                                            <td class="pl-8 text-right"><AmountText v-model='dlgCreateInvoice.marginSummary.material.sales'/> </td>
                                            <td class="pl-8 text-right text-bold"><AmountText v-model='dlgCreateInvoice.marginSummary.material.margin'/> </td>
                                            <td class="pl-8 text-right text-bold">
                                                <NoMarginCalculationHint v-if="!dlgCreateInvoice.marginSummary.material.canMarginPct" title="Marge kan niet worden berekend">
                                                    <p>De marge kan niet worden berekend omdat voor één of meerdere regels geen kostprijs of geen stukprijs is ingevuld.</p>
                                                    <p>Vul de tarieven in bij de artikelen, of vul de prijzen in de regels.</p>
                                                </NoMarginCalculationHint>                                                    

                                                <PercentageText v-else :class="{'text-success': dlgCreateInvoice.marginSummary.material.marginPct > 0, 'text-error': dlgCreateInvoice.marginSummary.material.marginPct < 0}" 
                                                    decimals="0" no-border v-model='dlgCreateInvoice.marginSummary.material.marginPct'/>    
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left">Overig</td>
                                            <td class="pl-8 text-right"><AmountText v-model='dlgCreateInvoice.marginSummary.other.purchase'/> </td>
                                            <td class="pl-8 text-right"><AmountText v-model='dlgCreateInvoice.marginSummary.other.sales'/> </td>
                                            <td class="pl-8 text-right text-bold"><AmountText v-model='dlgCreateInvoice.marginSummary.other.margin'/> </td>
                                            <td class="pl-8 text-right text-bold">
                                                <NoMarginCalculationHint v-if="!dlgCreateInvoice.marginSummary.other.canMarginPct" title="Marge kan niet worden berekend">
                                                    <p>De marge kan niet worden berekend omdat voor één of meerdere regels geen kostprijs of geen stukprijs is ingevuld.</p>
                                                    <p>Vul de tarieven in bij de artikelen, of vul de prijzen in de regels.</p>
                                                </NoMarginCalculationHint>                                                    

                                                <PercentageText v-else :class="{'text-success': dlgCreateInvoice.marginSummary.other.marginPct > 0, 'text-error': dlgCreateInvoice.marginSummary.other.marginPct < 0}" 
                                                    decimals="0" no-border v-model='dlgCreateInvoice.marginSummary.other.marginPct'/>    
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left"></td>
                                            <td class="text-bold"><AmountText v-model='dlgCreateInvoice.totals.purchase'/> </td>
                                            <td class="text-bold"><AmountText v-model='dlgCreateInvoice.totals.sales'/> </td>
                                            <td class="text-bold">
                                                <AmountText :class="{'text-success': dlgCreateInvoice.totals.marginPct > 0, 'text-error': dlgCreateInvoice.totals.marginPct <= 0}" v-model='dlgCreateInvoice.totals.margin'/> 
                                            </td>
                                            <td class="pl-8 text-right text-bold">
                                                <NoMarginCalculationHint v-if="!dlgCreateInvoice.totals.canMarginPct" title="Marge kan niet worden berekend">
                                                    <p>De marge kan niet worden berekend omdat voor één of meerdere regels geen kostprijs of geen stukprijs is ingevuld.</p>
                                                    <p>Vul de tarieven in bij de medewerkers of artikelen, of vul de prijzen in de regels.</p>
                                                </NoMarginCalculationHint>                                                    

                                                <PercentageText v-else :class="{'text-success': dlgCreateInvoice.totals.marginPct > 0, 'text-error': dlgCreateInvoice.totals.marginPct < 0}" 
                                                    decimals="0" no-border v-model='dlgCreateInvoice.totals.marginPct'/>    
                                            </td>

                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </td>
                        </tr>
                        </tfoot>


                    </template>


                </LocalTable>

            </v-form>

                    </v-col>
                </v-row>
        </template>

        <template v-slot:footer-left>
            <ActionButton main warning action="salesinvoice.modify" dusk="btn-add-product" :model="dlgCreateInvoice" :disabled="dlgCreateInvoice.isOpenOrLater" icon="refresh" @click='()=>dlgCreateInvoice.reload()'>Begin opnieuw</ActionButton>
        </template>

    </Dialog>
</div>
</template>

<script setup>

    // IMPORTANT NOTE: 
    // -- due to the nature of the functionallity, we have a FIXED set of columns in the local table. 
    // That is, we do not allow the user to configure the columns. 
    // There is no use to remove price, product or any other column. 
    // For that reason, the product -, hour - and text lines have a fixed set of fields. 
    // This setup is very easy. When we change this behaviour, more complex layout must be implemented 
    // in the line template components. That is because the number of columns is not fixed then, requiring
    // calculated colspans.


    import Dialog from '@shared/ui/dialogs/ModelDialog'
    import clsDialogModel from '@cls/clsDialogModel'
    import { computed, ref } from 'vue'
    import LocalTable from '@datatable/LocalTable'  
    import clsLocalTable from '@cls/clsLocalTable'
    import ActionButton from '@shared/ui/controls/buttons/ActionButton'
    import ActionMenuItem from "@controls/menu/ActionMenuItem.vue";
    import AmountText from '@controls/text/Amount.vue' 
    import PercentageText from '@controls/text/Percentage.vue' 
    import string from '@lib/string'
    import LineProduct from './LineProduct.vue'
    import LineHour from './LineHour.vue'
    import LineText from './LineText.vue'
    import Checkbox from '@controls/check/Checkbox.vue'
    import NoMarginCalculationHint from './NoMarginCalculationHint.vue'
    import { workorders as api } from '@/app/api'
    import noty from '@shared/lib/noty'
    import dlg from '@app/dlg'
    import Icon from '@controls/icons/Icon'
    import { date } from "@lib/date";

    let form=ref(null)
    let infoColExpanded=ref(false)


    import useDialogModelCreateInvoice from './DialogModelCreateInvoice.js'
    let dlgCreateInvoice = useDialogModelCreateInvoice({form: form});

    window.dlgci = dlgCreateInvoice;

    function setFocusToLastLineFirstInput() {
        var dia = document.getElementsByClassName("dialog-workorder_createinvoice"); 
        if (!dia) {
            return;
        }
        var trs = dia[0].getElementsByClassName('create-invoice-line');
        if (!trs || !trs.length) {
            return;
        }
        var tr = trs[trs.length-1];
        var inputs = tr.querySelector('input:not([type=checkbox])');
        var proses = tr.getElementsByClassName('ProseMirror');
        if (inputs && inputs.length) {
            inputs[0].focus();
            return;
        }
        if (proses && proses.length) {
            proses[proses.length-1].focus();
        }
    }
    async function addStandardText() {
        try {
            let selected = await dlg.promised.open("select_standardtext", {multiselect:false})
            if (!selected || !selected.length) {
                return;
            }
            dlgCreateInvoice.value.addTextLine(selected[0]);
        } catch (e) {} // canceled
    }
    function addEmptyText(evt) {
        dlgCreateInvoice.value.addTextLine({text: ''});
        setTimeout( ()=> setFocusToLastLineFirstInput(), 0);
    }

    function addInvoiceLine(evt) {
        dlgCreateInvoice.value.addProductLine({});
        setTimeout( ()=> setFocusToLastLineFirstInput(), 0);
    }
    async function addProductLine() {
        try {
            var fnMultiSelectCallback = function(selected) {
                if (!selected || !selected.length) {
                    return;
                }
                var arrProduct = selected[0]; 
                // The product can either be a product or a recipe. The select dialog returns both products and recipes.
                // For creation of the invoice, this does not matter.
                dlgCreateInvoice.value.addProductLine(selected[0]);                
            }

            await dlg.promised.open("select_product", {multiselect:false, fnMultiSelectCallback: fnMultiSelectCallback, filter: {type: 'rp'}}) // recipes and products
        } catch (e) {} // canceled
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // The local datatable
    //
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    // A FIXED SET OF COLUMNS!!!!!
    let headers = [

        { canhide: false, canmove: false, type: 'cmd'}, 
        { canhide: false, canmove: false, type: 'drag'}, 
//        { canhide: false, canmove: false, text: 'Type',             value: 'ihp_type',         class:'w-min-2 w-2 text-right pr-3'},
        { canhide: false, canmove: false, text: 'Aantal',           value: 'ihp_amount',         class:'w-min-2 w-2 text-right pr-3'},
        { canhide: false, canmove: false, text: 'Eenheid',          value: 'id_unity',           class:'w-min-3 w-3 pl-3'},
        { canhide: false, canmove: false, text: 'Omschrijving',     value: 'ihp_pd_name',        class: 'pl-3'   },
        { canhide: false, canmove: false, text: 'Artikel',          value: 'id_product',         class:'w-min-4 w-4 pl-3'},
        { canhide: false, canmove: false, text: 'Kostprijs',        value: 'ihp_purchase_price', class:'w-min-3 w-3 text-right pr-3'},
        { canhide: false, canmove: false, text: 'Stukprijs',        value: 'ihp_sales_price',    class:'w-min-3 w-3 text-right pr-3'},
        { canhide: false, canmove: false, text: "Marge",            value: "margin",             cellClass: "text-right pr-3", class:"w-3 text-right pr-3"}, 
        { canhide: false, canmove: false, text: "BTW",              value: "id_vat",             class:"w-min-3 w-3 pl-3"}, 
//        { canhide: false, canmove: false, text: "Totaal Kosten", value: "total_amount_purchase",        cellClass: "text-right pr-3", class:"w-3 text-right pr-3"}, 
        { canhide: false, canmove: false, text: "Totaal excl. BTW",  value: "total_amount_sales",        cellClass: "text-right pr-3", class:"w-3 text-right pr-3"}, 
    ];
    
    let tblLines = ref(new clsLocalTable("workorder.createinvoice.lines", headers, {
        noDataText: "Er zijn nog geen regels toegevoegd",
        noSort: true,
        model: dlgCreateInvoice, 
        modelLinesProp: 'lines',   
        
    }));

    function onToggleInfoCol() {
        infoColExpanded.value = !infoColExpanded.value;
    }
    function clsInfoCol() {
        return infoColExpanded.value ? "info-col-expanded col-sm-4 col-lg-3" : "";
    }


</script>